import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CameraCapture from './components/CameraCapture';
import Home from './components/home';  // Import the Home component

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/camera" element={<CameraCapture />} />
      </Routes>
    </Router>
  );
}

export default App;
